import React from 'react';
import './HowItWorks.css';

const HowItWorks: React.FC = () => {
    const steps = [
        {
            title: "Install the Add-on",
            description: "Get MailMeld from the Google Workspace Marketplace with a single click.",
            icon: "🔌"
        },
        {
            title: "Configure Your Preferences",
            description: "Choose your summary period, categories, and excluded senders.",
            icon: "⚙️"
        },
        {
            title: "Receive Daily Summaries",
            description: "Get organized email digests delivered to your inbox automatically.",
            icon: "📬"
        }
    ];

    return (
        <section className="how-it-works" id="how-it-works">
            <div className="container">
                <h2>How MailMeld Works</h2>
                <div className="steps-container">
                    {steps.map((step, index) => (
                        <div key={index} className="step-card">
                            <div className="step-icon">
                                <span>{step.icon}</span>
                            </div>
                            <div className="step-content">
                                <h3>{step.title}</h3>
                                <p>{step.description}</p>
                            </div>
                            {index < steps.length - 1 && (
                                <div className="step-connector">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M4 12h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M13 5l8 7-8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className="setup-time">
                    <span className="setup-icon">⚡</span>
                    <p>Setup takes less than 2 minutes!</p>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;